/**
 *  @class
 *  @function UnifiedProgressBar
 */

if (!customElements.get('unified-progress-bar')) {
  class UnifiedProgressBar extends HTMLElement {
    constructor() {
      super();
      this.previousTotal = 0;
    }

    connectedCallback() {
      this.total = parseInt(this.dataset.cartTotal, 10);
      this.giftMinimum = Math.round(parseInt(this.dataset.giftMinimum, 10) * (Shopify.currency.rate || 1));
      this.shippingMinimum = Math.round(parseInt(this.dataset.shippingMinimum, 10) * (Shopify.currency.rate || 1));

      this.statusText = this.querySelector('.progress-status');
      this.fill = this.querySelector('.unified-progress-bar--fill');
      this.shippingLabel = this.querySelector('.shipping-label');
      this.giftLabel = this.querySelector('.gift-label');

      // Listen for cart refresh events
      this.boundRefreshHandler = this.handleCartRefresh.bind(this);
      document.addEventListener('cart:refreshed', this.boundRefreshHandler);

      this.updateProgress();
    }

    disconnectedCallback() {
      // Clean up event listener when element is removed
      if (this.boundRefreshHandler) {
        document.removeEventListener('cart:refreshed', this.boundRefreshHandler);
      }
    }

    handleCartRefresh(event) {
      if (event.detail && event.detail.cart) {
        console.log('📊 Progress bar received cart update:', event.detail.cart.total_price);
        this.dataset.cartTotal = event.detail.cart.total_price;
        this.updateProgress();
      }
    }

    updateProgress() {
      // Update total from dataset in case it changed
      this.total = parseInt(this.dataset.cartTotal, 10);

      // Calculate percentage based on shipping minimum (£70 = 100%)
      let percentage = Math.min((this.total / this.shippingMinimum) * 100, 100);

      // Update fill with smooth transition
      if (this.fill) {
        requestAnimationFrame(() => {
          this.fill.style.width = `${percentage}%`;
        });
      }

      // Update dynamic status text above bar
      let statusMessage = '';
      const format = window.theme.settings.money_with_currency_format || "${{amount}}";

      if (this.total < this.shippingMinimum) {
        // Under £70: Show "£X away from free shipping"
        const remaining = this.shippingMinimum - this.total;
        statusMessage = `<span class="amount">${formatMoney(remaining, format)}</span> away from free shipping`;
      } else {
        // Over £70: Show "You've unlocked free shipping!"
        statusMessage = "You've unlocked free shipping!";
      }

      if (this.statusText) this.statusText.innerHTML = statusMessage;

      // Add/remove achieved class to label for checkmark display
      if (this.total >= this.shippingMinimum) {
        this.shippingLabel?.classList.add('achieved');
      } else {
        this.shippingLabel?.classList.remove('achieved');
      }

      this.previousTotal = this.total;
    }

    celebrateMilestone(type) {
      // Optional: Add confetti or notification here
      console.log(`${type} milestone achieved!`);
    }
  }

  customElements.define('unified-progress-bar', UnifiedProgressBar);
}
